export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  // Append and prepend necessary HTML elements
  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');
  $(`#${widgetName}`).prepend('<span class="multischedule_title">Upcoming Events</span>');

  // Function to determine max items visible based on window size
  function getMaxItemsVisible() {
    return $(window).width() < 850 ? 4 : 6;
  }

  // Initialize the widget once
  let currentMaxItemsVisible = getMaxItemsVisible();

  function initWidget() {
    // Clear existing content before reinitialization
    $(`#${widgetName} .multiFeatureContent`).empty();

    // Reinitialize the MultiScheduleFeature
    $(`#${widgetName}`).MultiScheduleFeature({
      scriptPath: widgetOpts.scriptPath,
      currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
      detectIpad: IPADDETECTED, // Replace with your actual detection logic
      allEventsLink: true,
      allEventsLinkText: 'VIEW Full calendar',
      hasImages: true,
      imageBackground: true,
      lazyLoadImages: true,
      buyNowButton: {
        visible: false,
        text: 'BUY NOW',
      },
      moreButton: {
        visible: false,
        text: 'More',
      },
      maxItemsVisible: currentMaxItemsVisible,
      isResponsive: false,
      hasDescription: false,
      textContainer: true,
      attributeOrder: {
        1: 'image',
        2: 'title',
        3: 'date',
        4: 'description',
        5: 'buttons',
      },
      multiFeatureLoaded: function () {
        // Create a mapping of abbreviated month names to full names
        const monthMap = {
          Jan: 'January',
          Feb: 'February',
          Mar: 'March',
          Apr: 'April',
          May: 'May',
          Jun: 'June',
          Jul: 'July',
          Aug: 'August',
          Sep: 'September',
          Oct: 'October',
          Nov: 'November',
          Dec: 'December',
        };

        $('#multiScheduleFeature .featureItem').each(function () {
          $(`#${widgetName} .featureItem .void-link`).removeAttr('href');
          let itemDescription = $(this).find('.featureItemDescription');
          let itemTitle = $(this).find('.featureItemTitle');

          // Get the event date and split it into parts
          let eventDate = $(this).find($('span.featureItemDate'));
          let dateText = eventDate.text();
          let abbreviatedMonth = dateText.slice(0, 3);
          let day = dateText.slice(4, 7).replace('-', '').replace(',', '');

          // Replace the abbreviated month with the full month name
          let fullMonth = monthMap[abbreviatedMonth] || abbreviatedMonth; // Fallback to original if not found
          eventDate.text(`${fullMonth} ${day}`);

          // Character limits for title and description
          let characterLimitTitle = 25;
          let itemTitleText = itemTitle.text();
          if (itemTitleText.length > characterLimitTitle) {
            let trimmedTextTitle = itemTitleText.substring(0, characterLimitTitle) + '...';
            itemTitle.text(trimmedTextTitle);
          }

          let characterLimitDescription = 49;
          let itemDescriptionText = itemDescription.text();
          if (itemDescriptionText.length > characterLimitDescription) {
            let trimmedTextDescription =
              itemDescriptionText.substring(0, characterLimitDescription) + '...';
            itemDescription.text(trimmedTextDescription);
          }
        });
      },
    });
  }

  // Initial setup
  initWidget();

  // Handle window resize
  $(window).on('resize', function () {
    const newMaxItemsVisible = getMaxItemsVisible();

    // Only reinitialize if the maxItemsVisible value has changed
    if (newMaxItemsVisible !== currentMaxItemsVisible) {
      currentMaxItemsVisible = newMaxItemsVisible;
      initWidget(); // Reinitialize the widget
    }
  });
}
